module.exports = __webpack_public_path__ + "kudos_7.svg?740eb55bbffe930ef131d835ecd39cb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_7.svg
// module id = 172
// module chunks = 0